export default function PrivacyPage() {
  return (
    <>
      {/* 整体背景 */}
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
        {/* 背景装饰图形 */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute w-[26rem] h-[26rem] bg-purple-300/25 rounded-full blur-3xl top-0 -left-24 animate-pulse" />
          <div className="absolute w-[30rem] h-[30rem] bg-indigo-300/25 rounded-full blur-3xl bottom-[-6rem] right-[-4rem] animate-pulse" />
          <div className="absolute w-[18rem] h-[18rem] bg-fuchsia-300/20 rounded-full blur-3xl top-1/3 right-10" />
        </div>

        {/* Header */}
        <div className="relative max-w-5xl mx-auto text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
            PRIVACY & POLICY
          </h1>
          <p className="text-[#5e4ca8] font-medium text-lg mt-4 tracking-wide">
            DATA PROTECTION NOTICE FOR CUSTOMERS
          </p>
          <div className="mx-auto mt-6 w-28 h-1 bg-gradient-to-r from-[#a076f9] to-[#7b5cff] rounded-full" />
          <p className="mt-4 text-[#2a0f4c]/80 max-w-2xl mx-auto">
            Your Data, Our Priority – learn how we collect, use, protect and retain your personal data.
          </p>
        </div>

        {/* 内容卡片 */}
        <div className="relative max-w-5xl mx-auto bg-white/70 backdrop-blur-2xl border border-white/60 rounded-3xl shadow-[0_18px_60px_rgba(138,79,255,0.18)] px-6 sm:px-10 py-10 text-sm md:text-base text-[#2a0f4c] space-y-8">
          {/* 第一块 */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9]">
              DATA PROTECTION NOTICE FOR CUSTOMERS
            </h2>
            <p>
              This Data Protection Notice (“Notice”) sets out the basis which P.T. TSV Teknologi Global Services (“we”, “us”, or “our”) 
              may collect, use, disclose or otherwise process personal data of our customers in accordance with the Personal Data 
              Protection Act (“PDPA”). This Notice applies to personal data in our possession or under our control, including personal 
              data in the possession of organisations which we have engaged to collect, use, disclose or process personal data for our purposes.
            </p>
          </section>

          {/* PERSONAL DATA */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              PERSONAL DATA
            </h2>

            <p className="font-semibold">
              1. As used in this Notice:
            </p>
            <p>
              “customer” means an individual who (a) has contacted us through any means to find out more about any goods or services 
              we provide, or (b) may, or has, entered into a contract with us for the supply of any goods or services by us; and
            </p>
            <p>
              “personal data” means data, whether true or not, about a customer who can be identified: (a) from that data; or 
              (b) from that data and other information to which we have or are likely to have access.
            </p>

            <p className="font-semibold">
              2. Depending on the nature of your interaction with us, some examples of personal data which we may collect from you 
              include name, email address and telephone number.
            </p>

            <p className="font-semibold">
              3. Other terms used in this Notice shall have the meanings given to them in the PDPA (where the context so permits).
            </p>
          </section>

          {/* COLLECTION, USE AND DISCLOSURE */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA
            </h2>

            <p className="font-semibold">
              4. We generally do not collect your personal data unless (a) it is provided to us voluntarily by you directly or via a 
              third party who has been duly authorised by you to disclose your personal data to us (your “authorised representative”) 
              after (i) you (or your authorised representative) have been notified of the purposes for which the data is collected, 
              and (ii) you (or your authorised representative) have provided written consent to the collection and usage of your 
              personal data for those purposes, or (b) collection and use of personal data without consent is permitted or required 
              by the PDPA or other laws. We shall seek your consent before collecting any additional personal data and before using 
              your personal data for a purpose which has not been notified to you (except where permitted or authorised by law).
            </p>

            <p className="font-semibold">
              5. We may collect and use your personal data for any or all of the following purposes:
            </p>
            <p>
              (a) performing obligations in the course of or in connection with our provision of the goods and/or services requested by you;
            </p>
            <p>
              (b) responding to, handling, and processing queries, requests, applications, complaints, and feedback from you; and
            </p>
            <p>
              (c) any other purposes for which you have provided the information.
            </p>

            <p className="font-semibold">
              6. We may disclose your personal data:
            </p>
            <p>
              (a) where such disclosure is required for performing obligations in the course of or in connection with our provision of the 
              goods and services requested by you.
            </p>

            <p className="font-semibold">
              7. The purposes listed in the above clauses may continue to apply even in situations where your relationship with us (for 
              example, pursuant to a contract) has been terminated or altered in any way, for a reasonable period thereafter (including, 
              where applicable, a period to enable us to enforce our rights under a contract with you).
            </p>
          </section>

          {/* WITHDRAWING YOUR CONSENT */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              WITHDRAWING YOUR CONSENT
            </h2>

            <p className="font-semibold">
              8. The consent that you provide for the collection, use and disclosure of your personal data will remain valid until such 
              time it is being withdrawn by you in writing. You may withdraw consent and request us to stop collecting, using and/or 
              disclosing your personal data for any or all of the purposes listed above by submitting your request in writing or via 
              email to our Data Protection Officer at the contact details provided below.
            </p>

            <p className="font-semibold">
              9. Upon receipt of your written request to withdraw your consent, we may require reasonable time (depending on the complexity 
              of the request and its impact on our relationship with you) for your request to be processed and for us to notify you of 
              the consequences of us acceding to the same, including any legal consequences which may affect your rights and liabilities 
              to us. In general, we shall seek to process your request within ten (10) business days of receiving it.
            </p>

            <p className="font-semibold">
              10. Whilst we respect your decision to withdraw your consent, please note that depending on the nature and scope of your request, 
              we may not be in a position to continue providing our goods or services to you and we shall, in such circumstances, notify you 
              before completing the processing of your request. Should you decide to cancel your withdrawal of consent, please inform us in 
              writing in the manner described in clause 8 above.
            </p>

            <p className="font-semibold">
              11. Please note that withdrawing consent does not affect our right to continue to collect, use and disclose personal data where 
              such collection, use and disclose without consent is permitted or required under applicable laws.
            </p>
          </section>

          {/* ACCESS / CORRECTION */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              ACCESS TO AND CORRECTION OF PERSONAL DATA
            </h2>

            <p className="font-semibold">
              12. If you wish to make (a) an access request for access to a copy of the personal data which we hold about you or information 
              about the ways in which we use or disclose your personal data, or (b) a correction request to correct or update any of your 
              personal data which we hold about you, you may submit your request in writing or via email to our Data Protection Officer at 
              the contact details provided below.
            </p>

            <p className="font-semibold">
              13. Please note that a reasonable fee may be charged for an access request. If so, we will inform you of the fee before 
              processing your request.
            </p>

            <p className="font-semibold">
              14. We will respond to your request as soon as reasonably possible. In general, our response will be within ten (10) business days. 
              Should we not be able to respond to your request within thirty (30) days after receiving your request, we will inform you in 
              writing within thirty (30) days of the time by which we will be able to respond to your request. If we are unable to provide 
              you with any personal data or to make a correction requested by you, we shall generally inform you of the reasons why we are 
              unable to do so (except where we are not required to do so under the PDPA).
            </p>
          </section>

          {/* PROTECTION */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              PROTECTION OF PERSONAL DATA
            </h2>

            <p className="font-semibold">
              15. To safeguard your personal data from unauthorised access, collection, use, disclosure, copying, modification, disposal or 
              similar risks, we have introduced appropriate administrative, physical and technical measures such as minimised collection of 
              personal data, authentication and access controls (such as good password practices, need-to-basis for data disclosure, etc.), 
              up-to-date antivirus protection, regular patching of operating system and other software, securely erase storage media in 
              devices before disposal, and web security measures against risks.
            </p>

            <p className="font-semibold">
              16. You should be aware, however, that no method of transmission over the Internet or method of electronic storage is completely 
              secure. While security cannot be guaranteed, we strive to protect the security of your information and are constantly reviewing 
              and enhancing our information security measures.
            </p>
          </section>

          {/* ACCURACY */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              ACCURACY OF PERSONAL DATA
            </h2>

            <p className="font-semibold">
              17. We generally rely on personal data provided by you (or your authorised representative). In order to ensure that your personal 
              data is current, complete and accurate, please update us if there are changes to your personal data by informing our Data 
              Protection Officer in writing or via email at the contact details provided below.
            </p>
          </section>

          {/* RETENTION */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              RETENTION OF PERSONAL DATA
            </h2>

            <p className="font-semibold">
              18. We may retain your personal data for as long as it is necessary to fulfil the purpose for which it was collected, or as 
              required or permitted by applicable laws.
            </p>

            <p className="font-semibold">
              19. We will cease to retain your personal data, or remove the means by which the data can be associated with you, as soon as it 
              is reasonable to assume that such retention no longer serves the purpose for which the personal data was collected, and is no 
              longer necessary for legal or business purposes.
            </p>
          </section>

          {/* TRANSFERS */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              TRANSFERS OF PERSONAL DATA OUTSIDE OF SINGAPORE
            </h2>

            <p className="font-semibold">
              20. We generally do not transfer your personal data to countries outside of Singapore. However, if we do so, we will obtain your 
              consent for the transfer to be made and we will take steps to ensure that your personal data continues to receive a standard of 
              protection that is at least comparable to that provided under the PDPA.
            </p>
          </section>

          {/* DPO */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              DATA PROTECTION OFFICER
            </h2>

            <p className="font-semibold">
              21. You may contact our Data Protection Officer if you have any enquiries or feedback on our personal data protection policies 
              and procedures, or if you wish to make any request, in the following manner:
            </p>
            <p>Name of DPO :</p>
            <p>Contact No. :</p>
            <p>Email Address :</p>
          </section>

          {/* EFFECT OF NOTICE */}
          <section className="space-y-3">
            <h2 className="text-lg md:text-xl font-bold text-[#6a2dd9] underline">
              EFFECT OF NOTICE AND CHANGES TO NOTICE
            </h2>

            <p className="font-semibold">
              22. This Notice applies in conjunction with any other notices, contractual clauses and consent clauses that apply in relation 
              to the collection, use and disclosure of your personal data by us.
            </p>

            <p className="font-semibold">
              23. We may revise this Notice from time to time without any prior notice. You may determine if any such revision has taken place 
              by referring to the date on which this DATA PROTECTION NOTICE FOR CUSTOMERS Notice was last updated. Your continued use of our 
              services constitutes your acknowledgement and acceptance of such changes.
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
